import { STORIES } from 'routes/routeConstant'

/**
 * Where an auto-login link is allowed to land.
 *
 * `next` arrives from a URL in an email, so it is treated as hostile input: only a same-origin
 * path may pass. Anything protocol-relative ("//evil.com"), absolute, or otherwise not starting
 * with a single slash falls back to /stories, so a doctored link can never turn a maayot login
 * into an open redirect.
 */
export function safeNext(next: string | null): string {
  if (!next) return STORIES
  if (!next.startsWith('/')) return STORIES
  if (next.startsWith('//')) return STORIES
  if (next.startsWith('/\\')) return STORIES
  return next
}
